import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { useMemo } from "react";
import { CustomRegistrationFormData, ProcessDataConfig } from "../types";
import { buildValidationSchema } from "../validation";

export const useCustomRegistrationForm = (config?: ProcessDataConfig) => {
  const validationSchema = useMemo(
    () => buildValidationSchema(config),
    [config]
  );

  return useForm<CustomRegistrationFormData>({
    resolver: joiResolver(validationSchema),
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
};
